import { MARQUEE_ITEMS } from "@/lib/content";

export function Marquee() {
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-white/10 bg-[#0D0F12] py-4"
      aria-label="Sitebound pack topics"
    >
      <div className="animate-marquee flex w-max items-center">
        {row.map((item, i) => (
          <span key={i} className="flex items-center" aria-hidden={i >= MARQUEE_ITEMS.length}>
            <span className="font-display px-6 text-xl font-semibold uppercase tracking-[0.18em] text-slate-400">
              {item}
            </span>
            <span className="h-2 w-2 rotate-45 bg-[#FF5500]" />
          </span>
        ))}
      </div>
    </div>
  );
}
